import React from 'react';
import { Control, FieldValues } from 'react-hook-form';
import { TextFieldWithController } from '../TextField';
import { EmailFieldWithController } from '../EmailField';
import ValidationError from '../ValidationError';
import {
  getEmailValidation,
  getPasswordValidation,
  getRequiredValidation,
} from '../lib/validationRules';

interface BasicSignupFieldsProperties<
  T extends FieldValues = FieldValues,
> {
  firstNameLabel: string;
  lastNameLabel: string;
  emailAddressLabel: string;
  passwordLabel: string;
  requiredValidationMessage: string;
  emailValidationMessage: string;
  passwordTooShortMessage: string;
  formatEmailSuggestion: (email: string) => React.ReactNode;
  control: Control<T>;
  errors: Record<string, unknown>;
}

const BasicSignupFields = <T extends FieldValues>({
  firstNameLabel,
  lastNameLabel,
  emailAddressLabel,
  passwordLabel,
  requiredValidationMessage,
  emailValidationMessage,
  passwordTooShortMessage,
  formatEmailSuggestion,
  control,
  errors,
}: BasicSignupFieldsProperties<T>) => (
  <>
    <div className="form-item">
      <TextFieldWithController
        name="firstName"
        control={control}
        rules={getRequiredValidation(requiredValidationMessage)}
        variant="filled"
        id="signup-first-name"
        label={firstNameLabel}
      />
      <ValidationError errors={errors} name="firstName" />
    </div>

    <div className="form-item">
      <TextFieldWithController
        name="lastName"
        control={control}
        rules={getRequiredValidation(requiredValidationMessage)}
        variant="filled"
        id="signup-last-name"
        label={lastNameLabel}
      />
      <ValidationError errors={errors} name="lastName" />
    </div>

    <div className="form-item">
      <EmailFieldWithController
        name="email"
        control={control}
        rules={
          getEmailValidation(
            emailValidationMessage,
            requiredValidationMessage,
          )
        }
        defaultValue=""
        variant="filled"
        id="signup-email"
        label={emailAddressLabel}
        formatSuggestion={formatEmailSuggestion}
        useStringOnClick
      />
      <ValidationError errors={errors} name="email" />
    </div>

    <div className="form-item">
      <TextFieldWithController
        name="password"
        control={control}
        rules={
          getPasswordValidation(
            passwordTooShortMessage,
            requiredValidationMessage,
          )
        }
        variant="filled"
        id="signup-password"
        type="password"
        label={passwordLabel}
      />
      <ValidationError errors={errors} name="password" />
    </div>
  </>
  );

export default BasicSignupFields;
